import { Center, Loader, Stack, Text } from '@mantine/core';
import { Navigate } from 'react-router-dom';
import { useMe } from '../api/hooks';
import { getAccessToken } from '../api/client';

/**
 * Gate for every authenticated route.
 *
 * It waits for /v1/me rather than trusting the presence of a token: a token that
 * exists but has been revoked would otherwise render the whole shell and then
 * fail every query inside it, which reads as a broken dashboard instead of an
 * expired session.
 */
export function RequireSession({ children }: { children: React.ReactNode }) {
  const hasToken = !!getAccessToken();
  const { data, isLoading, isError } = useMe({ enabled: hasToken, retry: false });

  if (!hasToken) return <Navigate to="/login" replace />;

  if (isLoading) {
    return (
      <Center h="100vh">
        <Stack align="center" gap="xs">
          <Loader size="sm" />
          <Text size="sm" c="dimmed">Restoring your session…</Text>
        </Stack>
      </Center>
    );
  }

  if (isError || !data) return <Navigate to="/login" replace />;

  return <>{children}</>;
}
